import { BrowserRouter } from "react-router-dom";
import styled from "styled-components"
import Category from "./components/Category";
import Search from "./components/Search";
import Pages from "./pages/Pages";


function App() {
    return ( <
        div className = "App" >
        <
        Center >
        <
        a href = "/" > < img src = "https://i.imgur.com/flmJXD3.png" / > < /a>

        <
        /Center>

        <
        Center > < p > Hecho por: < a href = "http://twitter.com/scthch" > Scthch < /a></p > < /Center>

        <
        BrowserRouter >
        <
        Search / >
        <
        Category / >
        <
        Pages / >
        <
        /BrowserRouter>

        <
        /div>
    );

}
const Center = styled.div `

display: flex;
justify-content:center; // centers in the flex direction and the default flex-direction is row



`
export default App;